export const configConst = [
    {id:1 , clientName:'Market Place', url:'marketplace.xeeva.com',clientLogo:'/content/images/ProductLogo2.jpeg' , isThemechanged: true},
    {id:2 , clientName:'MRE', url:'mre.xeeva.com',clientLogo:'' , isThemechanged: false},
    {id:3 , clientName:'Visteon', url:'visteon.xeeva.com',clientLogo:'' , isThemechanged: false},
];

export const userData=[
    {userId:1,userName:'rk',email:'rk@xeeva.com',assignedModules:[1,2,3,4]},
    {userId:2,userName:'rk1',email:'rk1@xeeva.com',assignedModules:[1,2]},
]